var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@lucidlink/uicore';
export const ModalActions = ({ children }) => {
    return _jsx(Box, { gap: "s", children: children });
};
_react_refresh_temp_1 = ModalActions;
$RefreshReg$(_react_refresh_temp_1, "ModalActions");
